import {
  Helmet as HelmetBase,
  HelmetProvider as HelmetProviderBase,
} from 'react-helmet-async'
import type { ComponentType, PropsWithChildren } from 'react'

export const Helmet = HelmetBase as unknown as ComponentType<PropsWithChildren>
export const HelmetProvider =
  HelmetProviderBase as unknown as ComponentType<PropsWithChildren>
